export default __webpack_public_path__ + "static/media/sl.0f15b4bd.png";